

<div *ngFor="let t of toolTips">

    <dx-popover *ngFor="let id of t.ids"
                target="#{{id}}"
                position="top"
                [showEvent]="{ name: 'mouseenter', delay: 1000}"
                [hideEvent]="{ name: 'mouseleave', delay: 500}">
        <dxo-animation>
            <dxo-show type="pop"
                      [from]="{ scale: 0 }"
                      [to]="{ scale: 1 }"></dxo-show>
            <dxo-hide type="fade"
                      [from]="1"
                      [to]="0"></dxo-hide>
        </dxo-animation>
        <div *dxTemplate="let data = model of 'content'">
            <div style="white-space: nowrap;">
                {{t.toolTip}}
            </div>
        </div>
    </dx-popover>

</div>


